<template lang="pug">
  #tmp-order
    #tmp-container.container.text-center.pt-5
      h3.font-weight-bold ご利用お申し込みの流れ
      img.mt-2.w-100.form-box(src="@/assets/images/step.png" )
      b-card.mx-auto.border-0.text-left.description_area
        p.mt-3.ml-2 この度は、弊社クラウドサービス（desknet's NEO／ChatLuck）
          | をご検討いただき、誠にありがとうございます。
        p.mt-4.mb-0.ml-2 下記にご入力いただくメールアドレス
          span.font-setting *
          | 宛に、本登録お申し込みサイトURLをご案内いたします。
        p.ml-2.mb-0 ご入力いただいたメールアドレス
          span.font-setting *
          | は、本契約後に送付される弊社からの重要なお知らせの送付先となりますので、
        p.ml-2 継続的に受信可能なメールアドレスをご入力ください。
        p.mt-1.ml-4
          span.font-setting *
          | :
          small ご契約完了後にご案内いたします「クラウド版サポートサイト」にて変更可能です。
        p.mt-5.mb-0.text-muted.font-weight-bold 【ご留意事項】
        p.mb-0.ml-4 ● メールが届かない・見つからない場合には、
          | 迷惑メールフォルダや受信設定をご確認ください。
        p.mb-0.ml-4 ● メールアドレスをお間違えの場合や仮登録メールの
          | 有効期限が切れた場合には、再度本画面よりお手続きください。
      b-card.mx-auto.w-50.border-0
        b-form-group.mt-3(label-align="left")
          .required-label-before.text-left {{data.tmp_order_mail.label}}
        b-form-input.mt-1(v-model="data.tmp_order_mail.value", required, placeholder="someone@example.com", data-testid="tmp_order_mail", :state="data.tmp_order_mail.error_msg_list.length === 0 ? null : false")
        div(v-if="data.tmp_order_mail.error_msg_list.length > 0", data-testid="tmp_order_mail_errors")
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of data.tmp_order_mail.error_msg_list") {{error_msg}}
        b-form-group.mt-4(label-align="left")
          .required-label-before.text-left {{data.re_mail_address.label}}
        b-form-input.mt-1(v-model="data.re_mail_address.value", required, data-testid="re_mail_address", placeholder="確認のためにもう一度入力してください", :state="data.re_mail_address.error_msg_list.length === 0 ? null : false")
        div(v-if="data.re_mail_address.error_msg_list.length > 0", data-testid="re_mail_address_errors")
          b-form-text.align-left.text-left.error-message-color(v-for="(error_msg) of data.re_mail_address.error_msg_list") {{error_msg}}
        .d-inline-flex.flex-column
          b-button.mx-auto.w-75.mt-4.mb-3(type="submit", variant="primary", data-testid="btn_mail_send", @click="mailSend", :disabled="isLoading") 申し込む
          router-link.text-left(:to="{name: 'Login'}") 既にネオジャパンのクラウドサービスをご利用中のお客様はこちら
</template>

<script>
import Api from "@/repositories/api"

const T201TmpOrderRepository = Api.get("t201TmpOrder")

export default {
  name: "tmpOrder",
  data() {
    return {
      data: {
        tmp_order_mail: { label: "メールアドレス", value: "", label_class: "form-label-class", error_msg_list: [] },
        re_mail_address: { label: "メールアドレス確認", value: "", error_msg_list: [] },
      }
    }
  },
  methods: {
    mailSend() {
      // Vueのインスタンス
      const vueData = this;

      // リクエストデータ作成
      let arRequestData = {
        tmp_order_mail: vueData.data.tmp_order_mail.value,  // メールアドレス
        re_mail_address: vueData.data.re_mail_address.value // メールアドレス確認
      };

      // 次へボタンをロックする
      this.isLoading = true;

      // 仮申込登録API呼び出し
      T201TmpOrderRepository.post(arRequestData)
      // 登録成功
      .then(() => {
        // 仮申込完了画面へ
        this.$router.push({
          name: "DoneTmpOrder",
          params: {
            p_mail_address: this.data.tmp_order_mail.value
          }
        })
      })
      // 登録失敗
      .catch((error) => {
        // 次へボタンをロックを解除する
        this.isLoading = false;

        // 内部エラーの場合はシステムエラー画面へ遷移する
        if (error.response.status >= 500) {
          // 仮申し込み処理は専用のシステムエラー画面へ
          this.apiError(error, "登録処理", "Tmp")
        }

        // 既存のエラーメッセージをリセット
        vueData.data.tmp_order_mail.error_msg_list = [];
        vueData.data.re_mail_address.error_msg_list = [];

        // エラーリストの読み込み
        const arErrorList = error.response.data.error_list;

        // 各エラーメッセージを画面に埋め込む
        for (let i = arErrorList.length - 1; i >= 0; i--) {
          // 入力項目特定
          switch (arErrorList[i].target) {
            // メールアドレス
            case "tmp_order_mail":
              vueData.data.tmp_order_mail.error_msg_list.push(arErrorList[i].error_msg)
              break
            // メールアドレス確認
            case "re_mail_address":
              vueData.data.re_mail_address.error_msg_list.push(arErrorList[i].error_msg)
              break
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.font-setting {
  color: red;
  font-size: smaller;
}
.description_area {
  max-width: 840px;
}
.form-box {
  max-width: 1200px;
}
p {
  font-size: 15px;
}
</style>